<template>
  <div>
    <div class="box info-box">
      <div class="box-header with-border">
          <h3 class="box-title text-warning">Profit-Loss</h3>
      </div>
      <!-- /.box-header -->
      <div class="box-body">
          <table class="table table-sm table-bordered table-striped table-hover">
            <thead>
              <tr>
                <td>Total Income</td>
                <td><strong>₹</strong>{{parseFloat(indInc + 0).toFixed(2)}}/-</td>
              </tr>
              <tr>
                <td>Total Expense</td>
                <td><strong>₹</strong>{{parseFloat(indExp + 0).toFixed(2)}}/-</td>
              </tr>
            </thead>
          </table>
                
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'profitloss',
  props: {
    indInc: 0,
    indExp: 0
  }
}
</script>
<style scoped>
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
</style>



// WEBPACK FOOTER //
// ProfitLoss.vue?51330592